module.exports = __webpack_public_path__ + "static/media/hero-bcg.1bc167c5.jpeg";